import React, { Component, Suspense } from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-multi-lang";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withAlert } from "react-alert";
import store from "./../../redux_store/store/index";
// import TextBox from "../../controls/TextBox";
import $ from "jquery";
import {
  Servicecalls,
  setDateAsuserDefined, Manualauditobject, orderType, orderTypeforprotocol, convertUTCDateToLocalDate

} from "../../custom_functions/Functions";
const TextBox = React.lazy(() => import("../../controls/TextBox"));

class Comment extends Component {
  popupOpened = false;

  constructor(props) {
    super(props);
    this.ELNurl = window.appUrl.ELN;
    this.inputRef = React.createRef();
    this.state = {
      IsLoader: false,
      Comment: "",
      UserName: $.session.get("Username"),
      Password:
        $.session.get("loggedfrom") !== undefined &&
          $.session.get("loggedfrom") === "1"
          ? $.session.get("azuretoken")
          : "",
      checkboxchecked: false,
      eDateVisible: false,
      ItemEsignDetails: undefined,
      popupOpened: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modulescren === undefined && nextProps.Isopen && nextProps?.isRender === undefined) {
      this.openPopup(nextProps);
    }
  }

  componentDidMount() {
    let eDate = setDateAsuserDefined(new Date(), "dd-MM-yyyy HH:mm:ss");
    if (this.props.modulescren !== undefined && this.props.modulescren === "Kendospread") {
      this.setState({
        IsLoader: this.props.Isopen,
        Comment: "",
        UserName: $.session.get("Username"),
        Password:
          $.session.get("loggedfrom") !== undefined &&
            $.session.get("loggedfrom") === "1"
            ? $.session.get("azuretoken")
            : "",
        checkboxchecked: false,
        eDateVisible: false,
        eSignedDate: eDate,
        ItemEsignDetails: this.props.ItemEsignDetails,
      });

      requestAnimationFrame(() => {
        setTimeout(() => {
          const pass = document.getElementById("ePassword");
          if (pass) pass.focus();
        }, 500);
      }, 200);
    }
    else if (this.props.modulescren === undefined) {
      this.openPopup(this.props);
    }
    else {
      this.setState({
        IsLoader: false,
        UserName: $.session.get("Username"),
        Password:
          $.session.get("loggedfrom") !== undefined &&
            $.session.get("loggedfrom") === "1" ? $.session.get("azuretoken")
            : "",
        checkboxchecked: false,
        eSignedDate: eDate,
        eDateVisible: false,
      });

      requestAnimationFrame(() => {
        setTimeout(() => {
          const pass = document.getElementById("ePassword");
          if (pass) pass.focus();
        }, 500);
      }, 200);
    }
  }

  componentWillUnmount() {
    this.setState({ IsLoader: false, UserName: $.session.get("Username") });
  }

  openPopup(nextProps) {
    if (nextProps.Isopen) {
      Servicecalls("" + this.ELNurl + "/Login/getCurrentUTCDate", {}, (response) => {
        let eDate = setDateAsuserDefined(
          convertUTCDateToLocalDate(new Date(response)),
          sessionStorage.getItem("userDefinedDate")
        )
        this.setState({ eSignedDate: eDate })

        requestAnimationFrame(() => {
          setTimeout(() => {
            const pass = document.getElementById("ePassword");
            if (pass) pass.focus();
          }, 500);
        }, 200);
      }, (res) => { }
      );
      this.setState({
        popupOpened: true
      });
    }
    this.setState({
      IsLoader: nextProps.Isopen,
      Comment: "",
      UserName: $.session.get("Username"),
      Password:
        $.session.get("loggedfrom") !== undefined &&
          $.session.get("loggedfrom") === "1"
          ? $.session.get("azuretoken")
          : "",
      checkboxchecked: this.state.checkboxchecked ? this.state.checkboxchecked : false,
      eDateVisible: false,
      ItemEsignDetails: nextProps.ItemEsignDetails,
    });
  }

  onNamechange(e) {
    this.setState({ Comment: e.target.value });
  }

  onCheckBoxChecked(e) {
    // let eDate = setDateAsuserDefined(new Date(), "dd-MM-yyyy HH:mm:ss");

    this.setState({
      checkboxchecked: e.target.checked,
      // eSignedDate: eDate,
      eDateVisible: e.target.checked ? true : false,
    });
  }

  closeModel() {

    this.setState({ IsLoader: false });

    if (this.props.Closecomment !== undefined) {
      this.props.Closecomment("");
    }
  }

  onUsernamechange(Value) {
    this.setState({ UserName: Value });
  }

  onUserPasswordchange(Value) {
    this.setState({ Password: Value });
  }

  saveESighn() {
    if (this.state.disableSave) return;

    this.setState({ disableSave: true });

    if (this.state.Comment.trim() === "" || this.state.Password.trim() === "") {
      this.setState({ IsLoader: true , disableSave: false});

      this.props.alert.error(this.props.t("orderapprovel.IDS_MSG_COMMENTSEMPTY"));
      let passObjDetAudit = {};
      Servicecalls("" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDetAudit,
        (res) => { }, (res) => { })
    } else {

      // $("#idSaveSheetAsComment").hide();
      // this.setState({ checkboxchecked: false });

      let audit = {};
      if (
        this.state.ItemEsignDetails !== undefined &&
        this.state.ItemEsignDetails !== null
      ) {
        audit = this.state.ItemEsignDetails;
      }
      let eDate = setDateAsuserDefined(new Date(), "dd-MM-yyyy HH:mm:ss");
      let passObject = {
        userID: sessionStorage.User,
        sUsername: this.state.UserName,
        sPassword: this.state.Password,
        sSiteCode: $.session.get("Usersite"),
        comments: this.state.Comment,
        // moduleName:this.state.ItemEsignDetails.moduleName,
        loggedfrom:
          $.session.get("loggedfrom") !== undefined &&
            $.session.get("loggedfrom") === "1"
            ? 1
            : 0,
        objsilentaudit: audit,
      };
      let passObjDetAudit = {};
      let ordertypename = "";
      if (this.props.module === "Sheet Orders") {

        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("orderapprovel.IDS_AUDIT_USERCOMMENT", {
          screen: orderType(this.props.Assigntestfor),
          username: store.getState().Loggeduser.username,
          batchid: this.props.batchid,
          dateandtime: eDate,
          comment: this.state.Comment,

        })

      }
      else if (this.props.module === "Sheet Templates") {
        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("Templates.Sheettemplates.IDS_AUDIT_SHEETUSERCOMMENT", {
          name: this.props.batchid,
          comment: this.state.Comment,

        })
      }
      else if (this.props.module === "Protocol Templates") {
        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("Templates.Protocoltemplates.IDS_AUDIT_PROTOCOLUSERCOMMENT", {
          name: this.props.batchid,
          comment: this.state.Comment,

        })
      }
      else if (this.props.module === "Protocol Orders") {

        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("orderapprovel.IDS_AUDIT_USERCOMMENT", {
          screen: orderTypeforprotocol(this.props.protocoltype),
          username: store.getState().Loggeduser.username,
          batchid: this.props.batchid,
          dateandtime: eDate,
          comment: this.state.Comment,

        })
      } else if (this.props.module === "LogBook") {
        ordertypename = "LogBook"
        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("orderapprovel.IDS_AUDIT_USERCOMMENT", {
          screen: ordertypename,
          username: store.getState().Loggeduser.username,
          batchid: this.props.batchid,
          dateandtime: eDate,
          comment: this.state.Comment,

        })
        // Report Designer
      } else if (this.props.module === "IDS_SCN_REPORTDESIGNER") {
        passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
        passObjDetAudit.objmanualaudit["comments"] = this.props.t("orderapprovel.IDS_AUDIT_USERCOMMENT", {
          screen: this.props.t("Audittrail.Audittrailhistory.Screenname.IDS_SCN_REPORTDESIGNER", {}),
          username: store.getState().Loggeduser.username,
          batchid: this.props.batchid,
          dateandtime: eDate,
          comment: this.state.Comment,

        })
      }
      Servicecalls(
        "" + this.ELNurl + "/Login/ValidateuserAndPassword",
        passObject,
        (res) => {
          if (res[0].objResponse.status) {

            $("#idSaveSheetAsComment").hide();
            // this.setState({ checkboxchecked: false });
            this.setState({ IsLoader: false , disableSave: false});

            this.props.Onsavecomment(this.state.Comment, setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(res[0].objResponse.currentutcdate)),
              sessionStorage.userDefinedDate
            ), store.getState().Loggeduser.username);
            Servicecalls("" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDetAudit, (res) => { }, (res) => { })
            setTimeout(() => { this.setState({ IsLoader: false }); })
            // this.closeModel();
          } else {
            //this.closeModel();

            $("#idSaveSheetAsComment").show();
            this.setState({ checkboxchecked: true, IsLoader: true, Password: "",disableSave: false });

            this.props.alert.error(this.props.t("Common.IDS_MSG_INVALID"));

            let passObjDetAudit = {};
            passObjDetAudit.objmanualaudit = Manualauditobject("eSign", this.props.module);
            passObjDetAudit.objmanualaudit["comments"] = this.props.t("orderapprovel.IDS_AUDIT_INVALIDPASSESSIGN", {
              //  module: this.props.module,
              module: this.props.t("Audittrail.Audittrailhistory.Screenname." + this.props.module, {}),
              batchid: this.props.batchid,
              action: this.props.actionperform
            })
            Servicecalls("" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDetAudit, (res) => { }, (res) => { })
          }
        },
        (res) => {
          $("#idSaveSheetAsComment").show(); //this.closeModel();
          this.setState({ checkboxchecked: true , disableSave: false});
        }
      );
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.state.IsLoader}
        className="modal-md smallPopup xl screen-centered-scroll commentPopup"
        onOpened={() => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              const pass = document.getElementById("ePassword");
              if (pass) pass.focus();
            }, 500);
          }, 200);
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            <label className="">
              {this.props.t("orderapprovel.IDS_LBL_ESIGN", { param: "" })}
            </label>
          </h5>
          {/* <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.closeModel.bind(this)}
          >
            <span aria-hidden="true">&times;</span>
          </button> */}
        </div>
        <ModalBody>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label className="form-label" multilingual="username">
                  {this.props.t("Setup.Usermaster.IDS_LBL_USERNAME", {
                    param: "",
                  })}
                </label>
                <Suspense fallback={<div></div>}>
                  <TextBox
                    txtType="text"
                    txtClsname={"form-control "}
                    txtName="Username"
                    txtDataType="Text"
                    txtmaxlength="100"
                    txtvalue={this.state.UserName}
                    sendData={this.onUsernamechange.bind(this)}
                    txtrequired="true"
                    autofocus="false"
                    disabled
                  />
                </Suspense>
              </div>
              <div className="form-group">
                <label className="required form-label" multilingual="password">
                  {this.props.t("orderapprovel.IDS_LBL_PASSWORD", {
                    param: "",
                  })}
                </label>
                <Suspense fallback={<div></div>}>
                  <TextBox
                    txtType="password"
                    txtClsname={"form-control "}
                    txtName="Password"
                    txtDataType="Text"
                    txtmaxlength="100"
                    txtvalue={this.state.Password}
                    txtid={"ePassword"}
                    sendData={this.onUserPasswordchange.bind(this)}
                    ref="txtPassword"
                    txtrequired="true"
                    autofocus="true"
                    disabled={
                      $.session.get("loggedfrom") !== undefined &&
                        $.session.get("loggedfrom") === "1"
                        ? true : undefined
                    }
                  />
                </Suspense>
                <div
                  id="audittrail_password_msgid"
                  className="inline-msg failed clearmsg_at"
                ></div>
              </div>
              <div className="form-group">
                <label
                  className="required form-label mb-2"
                  multilingual="username"
                >
                  {this.props.t("orderapprovel.IDS_LBL_COMMENT", {
                    param: "",
                  })}
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  value={this.state.Comment}
                  onChange={this.onNamechange.bind(this)}
                  autoComplete="off"
                  maxLength="200"
                  rows="2"
                />
              </div>
              {/* {this.state.eDateVisible ? ( */}
              <div className="form-group">
                <label className="form-label mb-2" multilingual="username">
                  {this.props.t("orderapprovel.IDS_LBL_ESIGNDATETIME", {
                    param: "",
                  })}
                </label>
                <Suspense fallback={<div></div>}>
                  <TextBox
                    txtType="text"
                    txtClsname={"form-control "}
                    txtName="Username"
                    txtDataType="Text"
                    txtmaxlength="100"
                    txtvalue={this.state.eSignedDate}
                    txtrequired="true"
                    autofocus="false"
                    disabled
                  />
                </Suspense>
              </div>
              {/* ) : (
                <></>
              )} */}
              <div className="form-group">
                <label className="form-label mb-2" multilingual="username">
                  {this.props.t("orderapprovel.IDS_LBL_ESIGN", {
                    param: "",
                  })}
                </label>
                <Suspense fallback={<div></div>}>
                  <p>
                    {this.props.t("orderapprovel.IDS_LBL_ESIGNNOTE", {
                      param: "",
                    })}
                  </p>
                </Suspense>
              </div>
              <div class="form-group">
                <input
                  type="checkbox"
                  className="mt-2"
                  value="0"
                  onChange={this.onCheckBoxChecked.bind(this)}
                />
                <label className="ml-2 mb-3" for="defaultCheck1">
                  {this.props.t("orderapprovel.IDS_LBL_AGREE", {
                    param: "",
                  })}
                </label>
              </div>
            </div>
          </div>
        </ModalBody>
        <div className="modal-footer">
          <button
            type="button"
            id="idSaveSheetAsComment"
            className="btn e-sig-s btn-user btn-primary-blue"
            onClick={this.saveESighn.bind(this)}
            disabled={!this.state.checkboxchecked ? true : false}
          >
            {this.props.t("orderapprovel.IDS_LBL_SUBMIT", {})}
          </button>
          <button
            type="button"
            className="btn e-sig-c modalbluebtn"
            onClick={this.closeModel.bind(this)}
          >
            {this.props.t("Header.IDS_LBL_CLOSE", { param: "" })}
          </button>
        </div>
      </Modal>
    );
  }
}
//export default withTranslation(Comment)
export default withAlert()(withTranslation(Comment));
